import { REPORT_ROLL_CALL_DETAIL_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";
import ReportRollCallDetail from "./ReportRollCallDetail";

function ReportRollCallDetailView() {
  return (
    <Switch>
      <ProtectedRoute
        path={REPORT_ROLL_CALL_DETAIL_ROUTE}
        key={REPORT_ROLL_CALL_DETAIL_ROUTE}
        component={ReportRollCallDetail}
        auth={true}
      />
    </Switch>
  );
}

export { ReportRollCallDetailView };
export default ReportRollCallDetailView;
